export default "__VITE_ASSET__b0LSe7UN__"